'use strict';
require('./url-search-params');
require('../modules/web.url');
require('../modules/web.url.can-parse');
require('../modules/web.url.parse');
require('../modules/web.url.to-json');
var path = require('../internals/path');

module.exports = path.URL;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/web/url.js
// module id = 483
// module chunks = 0